import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.reflect.to-string-tag.js';
import 'core-js/modules/es.reflect.construct.js';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import 'core-js/modules/es.array.from.js';
import 'core-js/modules/es.string.iterator.js';
import 'core-js/modules/es.promise.js';
import { __awaiter } from 'tslib';
import 'core-js/modules/es.error.cause.js';
import 'core-js/modules/es.error.to-string.js';
import 'core-js/modules/es.array.concat.js';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import 'core-js/modules/es.global-this.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.map.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.date.now.js';
import 'core-js/modules/es.date.to-string.js';
import 'core-js/modules/es.json.stringify.js';
import 'core-js/modules/es.function.bind.js';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import 'core-js/modules/es.object.assign.js';
import axios from 'axios';
import 'core-js/modules/es.array.includes.js';
import 'core-js/modules/es.string.includes.js';
import 'core-js/modules/web.timers.js';

/**
 * 常见的几类响应错误码类型
 */
var REQUEST_ERROR_CODE;
(function (REQUEST_ERROR_CODE) {
  /**
   * 请求终止，一般是请求被调用方手动取消
   */
  REQUEST_ERROR_CODE["aborted"] = "ECONNABORTED";
  /**
   * 网络不可用状态（断网）
   */
  REQUEST_ERROR_CODE["network"] = "ERR_NETWORK";
  /**
   * 网络请求超时
   */
  REQUEST_ERROR_CODE["timeout"] = "ETIMEDOUT";
  /**
   * 请求错误，例如支持的协议类型、响应 4xx 的错误码
   */
  REQUEST_ERROR_CODE["badRequest"] = "ERR_BAD_REQUEST";
  /**
   * 响应错误，例如响应 5xx 的错误码
   */
  REQUEST_ERROR_CODE["badResponse"] = "ERR_BAD_RESPONSE";
})(REQUEST_ERROR_CODE || (REQUEST_ERROR_CODE = {}));

/**
 * 响应状态码，尽量对齐http状态码
 */
var RESPONSE_STATUS;
(function (RESPONSE_STATUS) {
  RESPONSE_STATUS[RESPONSE_STATUS["unknown"] = -1] = "unknown";
  RESPONSE_STATUS[RESPONSE_STATUS["success"] = 200] = "success";
})(RESPONSE_STATUS || (RESPONSE_STATUS = {}));

var RESPONSE_STATUS_TEXT_SUCCESS = 'Success';
function success(data) {
  return {
    data: data,
    status: RESPONSE_STATUS.success,
    statusText: RESPONSE_STATUS_TEXT_SUCCESS
  };
}
function fail(statusText) {
  return {
    data: [],
    status: RESPONSE_STATUS.unknown,
    statusText: statusText
  };
}

/**
 * 拦截器职责链的抽象基类，负责公共的拦截器维护和拦截器链执行逻辑
 * @param T 请求参数的类型
 * @param V 响应参数的类型
 */
var AbstractInterceptorChain = /*#__PURE__*/function () {
  function AbstractInterceptorChain() {
    _classCallCheck(this, AbstractInterceptorChain);
    this.interceptors = [];
  }
  _createClass(AbstractInterceptorChain, [{
    key: "add",
    value: function add(interceptor) {
      this.interceptors.push(interceptor);
    }
  }, {
    key: "proceed",
    value: function proceed(config) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var chain;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              chain = Array.from(this.interceptors);
              this.fillBuildInInterceptors(chain, config);
              return _context.abrupt("return", this.dispatch(config, chain, 0));
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
    /**
     * 拦截器链调度执行的逻辑
     * PS: 这里必须用传 index 索引下标方式执行是因为传给 interceptor 的 next 方法是可能会被多次调度的
     * @param config 请求的配置信息
     * @param chain 拦截器链
     * @param index 当前执行的拦截器索引下标
     * @returns 响应对象
     */
  }, {
    key: "dispatch",
    value: function dispatch(config, chain, index) {
      var _this = this;
      if (index >= chain.length) {
        var response = success([]);
        return Promise.resolve(response);
      }
      var interceptor = chain[index];
      var next = function next() {
        return _this.dispatch(config, chain, index + 1);
      };
      return interceptor.intercept(next, config);
    }
  }]);
  return AbstractInterceptorChain;
}();

/**
 * jaspi通道
 */
var JsApi = /*#__PURE__*/function () {
  function JsApi() {
    _classCallCheck(this, JsApi);
    var _a, _b;
    this.canUseNativeAndroid = ((_a = globalThis.mqq) === null || _a === void 0 ? void 0 : _a.android) && ((_b = globalThis._mqqWebViewJSInterface) === null || _b === void 0 ? void 0 : _b.invoke);
    this.currentSeqId = 0;
    this.reqCallbacks = new Map();
  }
  _createClass(JsApi, [{
    key: "JSApiCallback",
    value: function JSApiCallback(response) {
      var reqCallback = this.reqCallbacks.get(response.callbackId);
      if (!reqCallback) {
        throw new Error("TypeError:[ark-request] the reqCallback of response[".concat(response.callbackId, "] can't found!"));
      }
      reqCallback.callback(response);
    }
    /**
       * 通过jsAPi和客户端通信
       * @param moduleName
       * @param method
       * @param requestData
       * @param callback
       */
  }, {
    key: "invokeNative",
    value: function invokeNative(moduleName, method, requestData, callback) {
      var _a;
      var requestConfig = requestData !== null && requestData !== void 0 ? requestData : {};
      var command = requestConfig.command;
      if (callback) {
        var callbackId = this.createReqSeq();
        this.reqCallbacks.set(callbackId, {
          callback: callback,
          command: command,
          startTime: Date.now()
        });
        requestConfig.callbackId = callbackId;
      }
      if (this.canUseNativeAndroid) {
        this.invokeNativeAndroid(moduleName, method, requestConfig);
      } else {
        (_a = globalThis.mqq) === null || _a === void 0 ? void 0 : _a.invoke(moduleName, method, requestConfig);
      }
    }
  }, {
    key: "invokeNativeAndroid",
    value: function invokeNativeAndroid(moduleName, method, requestData) {
      var _a;
      var url = "jsbridge://".concat(encodeURIComponent(moduleName), "/").concat(encodeURIComponent(method));
      if (requestData) {
        url += "?p=".concat(encodeURIComponent(JSON.stringify(requestData)));
      }
      (_a = globalThis._mqqWebViewJSInterface) === null || _a === void 0 ? void 0 : _a.invoke(url);
    }
  }, {
    key: "createReqSeq",
    value: function createReqSeq() {
      return this.currentSeqId += 1;
    }
  }]);
  return JsApi;
}();
if (!globalThis.jsApi) {
  globalThis.jsApi = new JsApi();
  if (!globalThis.JSApiCallback) {
    globalThis.JSApiCallback = globalThis.jsApi.JSApiCallback.bind(globalThis.jsApi);
  }
}
// eslint-disable-next-line import/no-mutable-exports
var JSApi = globalThis.jsApi;

var JSAPIInvokeStrategy = /*#__PURE__*/function () {
  function JSAPIInvokeStrategy() {
    _classCallCheck(this, JSAPIInvokeStrategy);
  }
  _createClass(JSAPIInvokeStrategy, [{
    key: "invoke",
    value: function invoke(config) {
      return new Promise(function (resolve, reject) {
        if (!config.namespace) {
          throw new Error('jsapi, namespace is null.');
        }
        var params = config.params || {};
        var callback = config.callback ? function () {
          for (var _len = arguments.length, res = new Array(_len), _key = 0; _key < _len; _key++) {
            res[_key] = arguments[_key];
          }
          resolve(success(res));
        } : undefined;
        try {
          JSApi.invokeNative(config.namespace, config.method, params, callback);
          if (!callback) {
            resolve(success([]));
          }
        } catch (error) {
          reject(fail('Error:[ark-request] Jsapi invokeNative fail.'));
        }
      });
    }
  }]);
  return JSAPIInvokeStrategy;
}();

function isFunction(value) {
  return Object.prototype.toString.call(value) === '[object Function]';
}

var MQQInvokeStrategy = /*#__PURE__*/function () {
  function MQQInvokeStrategy() {
    _classCallCheck(this, MQQInvokeStrategy);
  }
  _createClass(MQQInvokeStrategy, [{
    key: "invoke",
    value: function invoke(config) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var module, method;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (globalThis.mqq) {
                _context.next = 2;
                break;
              }
              throw new Error('UnknownError:[ark-request] mqq channel is undefined.');
            case 2:
              if (config.namespace) {
                _context.next = 4;
                break;
              }
              throw new Error('TypeError:[ark-request] mqq invoke has no namespace!');
            case 4:
              module = globalThis.mqq[config.namespace];
              method = module === null || module === void 0 ? void 0 : module[config.method];
              if (!(method && isFunction(method))) {
                _context.next = 10;
                break;
              }
              _context.next = 9;
              return this.innerModuleInvoke(method, config.params, config.callback);
            case 9:
              return _context.abrupt("return", _context.sent);
            case 10:
              _context.next = 12;
              return this.innerCoreInvoke(globalThis.mqq.invoke, config);
            case 12:
              return _context.abrupt("return", _context.sent);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
    /**
     * mqq中内置模块的调用方式
     * 根据观察，大部分mqq的内置模块调用主要为以下四种形式:
     * mqq.ui.method();
     * mqq.ui.method(params);
     * mqq.ui.method(params, callback);
     * mqq.ui.method(callback);
     * @param func 待调用的模块方法
     * @param params 参数，可选参数
     * @param callback 回调方法，可选参数
     */
  }, {
    key: "innerModuleInvoke",
    value: function innerModuleInvoke(func, params, callback) {
      return new Promise(function (resolve, reject) {
        var args = [];
        if (params) {
          args.push(params);
        }
        if (callback) {
          // 带callback的调用
          args.push(function () {
            for (var _len = arguments.length, res = new Array(_len), _key = 0; _key < _len; _key++) {
              res[_key] = arguments[_key];
            }
            resolve(success(res));
          });
        }
        try {
          func.apply(void 0, args);
          if (!callback) {
            resolve(success([]));
          }
        } catch (error) {
          reject(fail('Error:[ark-request] Mqq invoke module fail.'));
        }
      });
    }
    /**
     * mqq中core的invoke通用底层调用方式
     * @param config 请求信息
     */
  }, {
    key: "innerCoreInvoke",
    value: function innerCoreInvoke(func, config) {
      return new Promise(function (resolve, reject) {
        try {
          func(config.namespace, config.method, config.params, function () {
            for (var _len2 = arguments.length, res = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              res[_key2] = arguments[_key2];
            }
            resolve(success(res));
          });
        } catch (error) {
          reject(fail("Error:[ark-request] Mqq invoke core[".concat(config.namespace, ".").concat(config.method, "] fail.")));
        }
      });
    }
  }]);
  return MQQInvokeStrategy;
}();

var _channels;
var INVOKE_CHANNEL;
(function (INVOKE_CHANNEL) {
  INVOKE_CHANNEL["mqq"] = "mqq";
  INVOKE_CHANNEL["jsapi"] = "jsapi";
})(INVOKE_CHANNEL || (INVOKE_CHANNEL = {}));
var DEFAULT_CONFIG$1 = {
  /**
   * 默认的客户端通信通道为mqq
   */
  schema: 'mqq',
  /**
   * 配置支持的客户端通道
   */
  channels: (_channels = {}, _defineProperty(_channels, INVOKE_CHANNEL.mqq, MQQInvokeStrategy), _defineProperty(_channels, INVOKE_CHANNEL.jsapi, JSAPIInvokeStrategy), _channels)
};

/**
 * 具体的调用客户端通道的拦截器
 * 通过配置的不同客户端通道的具体策略触发调用执行
 */
var CallNativeInterceptor = /*#__PURE__*/function () {
  function CallNativeInterceptor() {
    _classCallCheck(this, CallNativeInterceptor);
  }
  _createClass(CallNativeInterceptor, [{
    key: "intercept",
    value: function intercept(next, config) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var StrategyClasses;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (config.schema) {
                _context.next = 2;
                break;
              }
              throw Error("TypeError[ark-request]: the schema of request(".concat(config.namespace, ".").concat(config.method, ") is undefined."));
            case 2:
              StrategyClasses = DEFAULT_CONFIG$1.channels[config.schema];
              if (StrategyClasses) {
                _context.next = 5;
                break;
              }
              throw Error("TypeError[ark-request]: can't match strategy to handle request(".concat(config.schema, ".").concat(config.namespace, ".").concat(config.method, ")."));
            case 5:
              _context.next = 7;
              return new StrategyClasses().invoke(config);
            case 7:
              return _context.abrupt("return", _context.sent);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    }
  }]);
  return CallNativeInterceptor;
}();

function _createSuper$4(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * 客户端通道的拦截器职责链子类
 * 职责链次序为 start -> [自定义拦截器] -> [网络请求] - end;
 */
var NativeInterceptorChain = /*#__PURE__*/function (_AbstractInterceptorC) {
  _inherits(NativeInterceptorChain, _AbstractInterceptorC);
  var _super = _createSuper$4(NativeInterceptorChain);
  function NativeInterceptorChain() {
    _classCallCheck(this, NativeInterceptorChain);
    return _super.apply(this, arguments);
  }
  _createClass(NativeInterceptorChain, [{
    key: "fillBuildInInterceptors",
    value: function fillBuildInInterceptors(chain) {
      chain.push(new CallNativeInterceptor());
      return chain;
    }
  }]);
  return NativeInterceptorChain;
}(AbstractInterceptorChain);

var NativeRequest = /*#__PURE__*/function () {
  function NativeRequest(interceptors) {
    _classCallCheck(this, NativeRequest);
    this.interceptors = interceptors;
  }
  _createClass(NativeRequest, [{
    key: "invoke",
    value: function invoke(config) {
      this.interceptors.proceed(Object.assign({
        schema: DEFAULT_CONFIG$1.schema
      }, config)).then(function (response) {
        var _a2;
        var _a, _b;
        var data = response.data;
        (_a = config.callback) === null || _a === void 0 ? void 0 : (_a2 = _a).call.apply(_a2, [config].concat(_toConsumableArray(data)));
        if (config.removeCallback && ((_b = config.params) === null || _b === void 0 ? void 0 : _b.callbackId)) {
          // window上的jsapi可能被提前赋值，给jsapi类新增方法不生效
          // @ts-ignore
          JSApi.reqCallbacks["delete"](config.params.callbackId);
        }
      });
    }
  }, {
    key: "register",
    value: function register(name, handler) {
      if (!isFunction(handler)) {
        throw new Error("TypeError:[ark-request] The handler[".concat(name, "] to register is not function."));
      }
      var channel = this.getNativeChannel();
      var funcName = this.generateCallbackName(name);
      channel[funcName] = handler;
    }
  }, {
    key: "unregister",
    value: function unregister(name) {
      var channel = this.getNativeChannel();
      var callback = this.generateCallbackName(name);
      channel[callback] = undefined;
    }
  }, {
    key: "notify",
    value: function notify(name) {
      var channel = this.getNativeChannel();
      var callback = this.generateCallbackName(name);
      var handler = channel[callback];
      if (!isFunction(handler)) {
        throw new Error("TypeError:[ark-request] The handler[".concat(name, "] is not function!"));
      }
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      handler.apply(void 0, args);
    }
  }, {
    key: "generateCallbackName",
    value: function generateCallbackName(name) {
      // 这里暂时兼容现网写法，后续和客户端协商后这里名字建议加统一前缀
      return name;
    }
  }, {
    key: "getNativeChannel",
    value: function getNativeChannel() {
      // 这里暂时兼容现网写法，后续和客户端协商后这里不直接挂载在window上，考虑挂载在内部或window的子属性上
      return window;
    }
  }]);
  return NativeRequest;
}();

function createNativeRequestInstance() {
  var interceptorChain = new NativeInterceptorChain();
  return new NativeRequest(interceptorChain);
}
var nativeRequest = createNativeRequestInstance();

var DEFAULT_CONFIG = {
  /**
   * 默认支持最多三次重试
   */
  maxRetry: 3
};

/**
 * 具体的网络请求逻辑
 * 目前采用的策略是直接调用axios库的request接口执行
 */
var CallNetworkInterceptor = /*#__PURE__*/function () {
  function CallNetworkInterceptor() {
    _classCallCheck(this, CallNetworkInterceptor);
  }
  _createClass(CallNetworkInterceptor, [{
    key: "intercept",
    value: function intercept(next, config) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return axios.request(config);
            case 2:
              return _context.abrupt("return", _context.sent);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    }
  }]);
  return CallNetworkInterceptor;
}();

var BaseBackoff = /*#__PURE__*/function () {
  function BaseBackoff(duration) {
    _classCallCheck(this, BaseBackoff);
    this.duration = duration;
    this.attempt = 0;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _createClass(BaseBackoff, [{
    key: "next",
    value: function next(context) {
      throw new Error('Method not implemented.');
    }
  }]);
  return BaseBackoff;
}();

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * 一个常量退避策略，支持配置最大的退避次数
 * PS: 每次退避的时间都是常量值
 */
var ConstantBackoff = /*#__PURE__*/function (_BaseBackoff) {
  _inherits(ConstantBackoff, _BaseBackoff);
  var _super = _createSuper$3(ConstantBackoff);
  /**
   * @param interval 每次退避时间的常量值
   * @param limit 最大退避次数
   */
  function ConstantBackoff(interval, limit) {
    var _this;
    _classCallCheck(this, ConstantBackoff);
    _this = _super.call(this, interval);
    _this.limit = limit;
    return _this;
  }
  _createClass(ConstantBackoff, [{
    key: "next",
    value: function next() {
      if (this.limit === undefined) {
        return this;
      }
      if (this.attempt >= this.limit) {
        return undefined;
      }
      this.attempt += 1;
      return this;
    }
  }]);
  return ConstantBackoff;
}(BaseBackoff);
new ConstantBackoff(0, 0);

// 不对任何异常进行尝试
var dontHandleErrorFilter = function dontHandleErrorFilter() {
  return false;
};
// 不对任何相应结果进行重试
var dontHandleResultFilter = function dontHandleResultFilter() {
  return false;
};

var ExecuteWrapper = /*#__PURE__*/function () {
  function ExecuteWrapper() {
    var errorFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : dontHandleErrorFilter;
    var resultFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : dontHandleResultFilter;
    _classCallCheck(this, ExecuteWrapper);
    this.errorFilter = errorFilter;
    this.resultFilter = resultFilter;
  }
  _createClass(ExecuteWrapper, [{
    key: "invoke",
    value: function invoke(fn, context) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var value, error, handled;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fn(context);
            case 3:
              value = _context.sent;
              if (this.resultFilter(value)) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return", {
                success: value
              });
            case 6:
              return _context.abrupt("return", {
                value: value
              });
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              error = _context.t0;
              handled = this.errorFilter(error);
              if (handled) {
                _context.next = 15;
                break;
              }
              throw error;
            case 15:
              return _context.abrupt("return", {
                error: error
              });
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 9]]);
      }));
    }
  }]);
  return ExecuteWrapper;
}();

var delay = function delay(duration) {
  var timeout = Math.max(duration, 0);
  if (timeout === 0) {
    return Promise.resolve();
  }
  return new Promise(function (resolve) {
    return setTimeout(resolve, timeout);
  });
};
var RetryPolicy = /*#__PURE__*/function () {
  function RetryPolicy(options) {
    _classCallCheck(this, RetryPolicy);
    var _a;
    this.options = options;
    this.executor = new ExecuteWrapper(options.errorFilter, options.resultFilter);
    this.backoffFactory = (_a = options.backoffFactory) !== null && _a !== void 0 ? _a : new ConstantBackoff(0, options.maxRetry);
  }
  _createClass(RetryPolicy, [{
    key: "execute",
    value: function execute(fn) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var retries, retryContext, result, backoffContext, backoff;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              retries = 0;
            case 1:
              retryContext = {
                attempt: retries,
                startTimestamp: Date.now()
              };
              _context.next = 4;
              return this.executor.invoke(fn, retryContext);
            case 4:
              result = _context.sent;
              if (!('success' in result)) {
                _context.next = 7;
                break;
              }
              return _context.abrupt("return", result.success);
            case 7:
              if (!(retries < this.options.maxRetry)) {
                _context.next = 14;
                break;
              }
              backoffContext = {
                attempt: retries + 1,
                result: result
              };
              backoff = this.backoffFactory.next(backoffContext); // 2.1. 如果设置了退避策略，则进行退避处理
              if (!backoff) {
                _context.next = 13;
                break;
              }
              _context.next = 13;
              return delay(backoff.duration);
            case 13:
              return _context.abrupt("continue", 17);
            case 14:
              if (!('error' in result)) {
                _context.next = 16;
                break;
              }
              throw result.error;
            case 16:
              return _context.abrupt("return", result.value);
            case 17:
              retries++;
              _context.next = 1;
              break;
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }]);
  return RetryPolicy;
}();

var defaultTimeoutErrorFilter = function defaultTimeoutErrorFilter(error) {
  var _a;
  return (_a = error.message) === null || _a === void 0 ? void 0 : _a.includes('timeout');
};
/**
 * 负责重试处理逻辑的拦截器
 */
var RetryInterceptor = /*#__PURE__*/function () {
  function RetryInterceptor() {
    _classCallCheck(this, RetryInterceptor);
  }
  _createClass(RetryInterceptor, [{
    key: "intercept",
    value: function intercept(next, config) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this = this;
        var retryPolicy;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(config.maxRetry <= 0)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", next());
            case 2:
              retryPolicy = new RetryPolicy(Object.assign({
                maxRetry: DEFAULT_CONFIG.maxRetry,
                errorFilter: defaultTimeoutErrorFilter
              }, config));
              return _context2.abrupt("return", retryPolicy.execute(function (context) {
                return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  var response;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return next();
                      case 2:
                        response = _context.sent;
                        response.retryContext = context;
                        return _context.abrupt("return", response);
                      case 5:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
              }));
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
    }
  }]);
  return RetryInterceptor;
}();

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * 网络请求的拦截器职责链子类
 * 职责链次序为 start -> [自定义拦截器] -> [重试拦截器] -> [网络请求] -> end;
 */
var NetworkInterceptorChain = /*#__PURE__*/function (_AbstractInterceptorC) {
  _inherits(NetworkInterceptorChain, _AbstractInterceptorC);
  var _super = _createSuper$2(NetworkInterceptorChain);
  function NetworkInterceptorChain() {
    _classCallCheck(this, NetworkInterceptorChain);
    return _super.apply(this, arguments);
  }
  _createClass(NetworkInterceptorChain, [{
    key: "fillBuildInInterceptors",
    value: function fillBuildInInterceptors(chain, config) {
      var _a;
      var maxRetry = (_a = config.maxRetry) !== null && _a !== void 0 ? _a : DEFAULT_CONFIG.maxRetry;
      if (maxRetry > 0) {
        chain.push(new RetryInterceptor());
      }
      chain.push(new CallNetworkInterceptor());
      return chain;
    }
  }]);
  return NetworkInterceptorChain;
}(AbstractInterceptorChain);

var NetworkRequest = /*#__PURE__*/function () {
  function NetworkRequest(defaults, interceptors) {
    _classCallCheck(this, NetworkRequest);
    this.defaults = defaults;
    this.interceptors = interceptors;
  }
  _createClass(NetworkRequest, [{
    key: "get",
    value: function get(url, config) {
      return this.dispatchRequest('get', url, undefined, config);
    }
  }, {
    key: "post",
    value: function post(url, data, config) {
      return this.dispatchRequest('post', url, data, config);
    }
  }, {
    key: "request",
    value: function request(config) {
      return this.interceptors.proceed(Object.assign(Object.assign({}, this.defaults), config));
    }
  }, {
    key: "dispatchRequest",
    value: function dispatchRequest(method, url, data, config) {
      var _a;
      var requestConfig = config !== null && config !== void 0 ? config : {};
      var headers = (_a = requestConfig.headers) !== null && _a !== void 0 ? _a : {};
      if (requestConfig.contentType) {
        headers['Content-Type'] = requestConfig.contentType;
      }
      return this.interceptors.proceed(Object.assign(Object.assign(Object.assign({}, this.defaults), requestConfig), {
        url: url,
        method: method,
        headers: headers,
        data: data !== null && data !== void 0 ? data : requestConfig.data
      }));
    }
  }]);
  return NetworkRequest;
}();

function createNetworkRequestInstance(config) {
  var interceptorChain = new NetworkInterceptorChain();
  return new NetworkRequest(config || DEFAULT_CONFIG, interceptorChain);
}
var networkRequest = createNetworkRequestInstance();

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var CustomBackoff = /*#__PURE__*/function (_BaseBackoff) {
  _inherits(CustomBackoff, _BaseBackoff);
  var _super = _createSuper$1(CustomBackoff);
  function CustomBackoff(generator) {
    var _this;
    _classCallCheck(this, CustomBackoff);
    var _a;
    _this = _super.call(this, (_a = generator({
      attempt: 0
    })) !== null && _a !== void 0 ? _a : 0);
    _this.generator = generator;
    return _this;
  }
  _createClass(CustomBackoff, [{
    key: "next",
    value: function next(context) {
      var duration = this.generator(context);
      if (!duration) {
        return undefined;
      }
      this.duration = duration;
      return this;
    }
  }]);
  return CustomBackoff;
}(BaseBackoff);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var format = function format(duration) {
  return Math.max(duration !== null && duration !== void 0 ? duration : 0, 0);
};
/**
 * 指定退避时间的退避策略，配置的退避时间的个数即为最大退避次数
 * 例如：配置配置时间数组为 [10, 20, 30]，即表示最大退避 3 次，每次退避时间分别为 10, 20, 30 ms
 */
var IterableBackoff = /*#__PURE__*/function (_BaseBackoff) {
  _inherits(IterableBackoff, _BaseBackoff);
  var _super = _createSuper(IterableBackoff);
  /**
   * @param durations 退避时间数组，单位为 ms
   */
  function IterableBackoff(durations) {
    var _this;
    _classCallCheck(this, IterableBackoff);
    var _a;
    _this = _super.call(this, (_a = format(durations[0])) !== null && _a !== void 0 ? _a : 0);
    _this.durations = durations;
    return _this;
  }
  _createClass(IterableBackoff, [{
    key: "next",
    value: function next() {
      if (this.attempt >= this.durations.length) {
        return undefined;
      }
      this.duration = format(this.durations[this.attempt]);
      this.attempt += 1;
      return this;
    }
  }]);
  return IterableBackoff;
}(BaseBackoff);

var index = {};

export { BaseBackoff, ConstantBackoff, CustomBackoff, IterableBackoff, REQUEST_ERROR_CODE, RetryPolicy, createNativeRequestInstance, createNetworkRequestInstance, index as default, nativeRequest, networkRequest };
//# sourceMappingURL=index.js.map
